import { Alert, AlertTitle } from '@material-ui/lab'
import { chain } from 'lodash'
import React, { useContext, useState } from 'react'
import { useTranslation } from 'react-i18next'
import ControlContainer from '../components/ControlContainer'
import { OrderContext } from '../OrderContext'
import { CancelButton, FakeNextButton, PreviousButton } from '../StepperButtons'
import ReturnList from './ReturnList'
import ReturnSearch from './ReturnSearch'
import { Button, Modal, makeStyles } from '@material-ui/core'

const useStyles = makeStyles(theme => ({
    paper: {
        position: 'absolute',
        top: '50%',
        left: '50%',
        transform: 'translate(-50%, -50%)',
        width: 350,
        backgroundColor: theme.palette.background.paper,
        border: '2px solid #000',
        boxShadow: theme.shadows[5],
        padding: theme.spacing(2, 4, 3),
    },
}));
const AddItems = () => {
    const { order, returnsEnabled, exchangesEnabled, dispatch, activeStep, setActiveStep } = useContext(OrderContext)
    const [displayError, setDisplayError] = useState(false)
    const [showAddMoreModal, setShowAddMoreModal] = useState(false)
    
    const { t } = useTranslation()
    const classes = useStyles();

    const disabledReason = chain(order)
        .some(mb => mb.reason === '_')
        .value()

    const disabledComplaint = chain(order)
        .some(mb => mb.reason === 'Product Complaint')
        .value()

    const disabledPoRef = chain(order)
        .some(mb => (mb.poref?.length || 0) > 35)
        .value()

    const totalQuantity = chain(order).reduce((acc, val) => acc + (val.quantity || 0), 0).value();
    const disabledQuantity = totalQuantity < 1 || Object.keys(order || {}).length === 0

    const disabled = disabledReason || disabledComplaint || disabledPoRef || disabledQuantity

    // Handler for Continue button
    const handleContinue = () => {
        if (disabled) {
            setDisplayError(true);
            return;
        }
        // Show modal only if at least one item and not already shown
        if (totalQuantity > 0 ) {
            setShowAddMoreModal(true);
            
        } else {
            if (typeof dispatch === 'function') dispatch({ type: 'CleanOrder' });
            setActiveStep(activeStep + 1);
            window.scrollTo(0, 0);
        }
    };

    return (
        <>
            <ReturnSearch />

            <ReturnList />

            {
                displayError && (disabledReason || disabledComplaint) &&
                <Alert severity="error" style={{ marginTop: 60, marginBottom: 30 }}>
                    <AlertTitle>
                        {disabledReason && t('error_missing_return_reason')}
                        {!disabledReason && disabledComplaint && t('error_cannot_return_product_compliant')}
                    </AlertTitle>
                </Alert>
            }

            <ControlContainer>
                <Button
                    size='large'
                    variant="contained"
                    color="primary"
                    onClick={handleContinue}
                    disabled={disabledQuantity}
                >
                    {t('continue')}
                </Button>
                {(!returnsEnabled && !exchangesEnabled) && <PreviousButton />}
                <CancelButton />
            </ControlContainer>

            <Modal
                open={showAddMoreModal}
                onClose={() => setShowAddMoreModal(false)}
                aria-labelledby='add-more-modal-title'
                aria-describedby='add-more-modal-description'
            >
                <div className={classes.paper}>
                    <p>{t('add_more_items_modal') || 'Do you want to add more items?'}</p>
                    <div style={{ width: '100%', marginTop: 30, display: 'flex', flexDirection: 'column', gap: 15 }}>
                        <Button color='primary' variant='contained' onClick={() => setShowAddMoreModal(false)}>
                            {t('yes_modal')}
                        </Button>
                        <Button color='secondary' variant='contained' onClick={() => {
                            setShowAddMoreModal(false);
                            if (typeof dispatch === 'function') dispatch({ type: 'CleanOrder' });
                            setActiveStep(activeStep + 1);
                            window.scrollTo(0, 0);
                        }}>
                            {t('no_modal')}
                        </Button>
                    </div>
                </div>
            </Modal>
        </>
    )
}

export default AddItems
